var moment = require('moment');
require('moment/locale/de');

var deepequal = require('deep-equal');

class openingTimes {

    constructor(ot) {
        this.exceptions = ot.exceptions
        ||  {};
        this.days = this.mapDays(ot);
    }

    mapDays(days) {
        var map = {
            monday: 0,
            tuesday: 1,
            wednesday: 2,
            thursday: 3,
            friday: 4,
            saturday: 5,
            sunday: 6,
        }
        var arr = [];
        for (var day in days) {
            if (days.hasOwnProperty(day) && map.hasOwnProperty(day)) {
                arr[map[day]] = days[day];
            }
        }
        return arr;
    }

    parseTime(timeStr, fromDate) {
        timeStr = moment(fromDate).format('YYYYMMDD') + timeStr
        return moment(timeStr, 'YYYYMMDDHH:mm');
    }

    getOpeningTimeOfDate(date, excludeException) {
        date = moment(date);

        if (!excludeException) {
            // check Exepitons
            var exception = this.getExceptionOfDate(date);
            if (exception) {
                return exception;
            }
        }

        var day = date.isoWeekday() - 1;

        return this.days[day] ||  [];
    }

    getExceptionOfDate(date) {
        date = moment(date);
        var exeption;

        for (var key in this.exceptions) {
            var el = this.exceptions[key];
            var d = moment.unix(key);
            if (date.isSame(d, 'day')) {
                exeption = el;
                break;
            }
        }

        return exeption;
    }

    isOpen(date) {
        date = moment(date);
        var ot = this.getOpeningTimeOfDate(date);

        var open = false;
        for (let i = 0; i < ot.length; i++) {
            var element = ot[i];
            open = open || date.isBetween(this.parseTime(element.from), this.parseTime(element.to));
        }
        return open;
    }

    getEvents(dayRange) {
        if (!dayRange) {
            dayRange = 2;
        }

        var events = [];
        var now = moment();
        for (var i = 0; i < dayRange; i++) {
            var date = now.clone().startOf('day').add(i, 'day');
            var otOfDate = this.getOpeningTimeOfDate(date);

            for (let index = 0; index < otOfDate.length; index++) {
                var element = otOfDate[index];
                var fromDate = this.parseTime(element.from, date);
                if (now.isBefore(fromDate, 'minute')) {
                    events.push({
                        event: 'opens',
                        moment: fromDate
                    });
                }
                var toDate = this.parseTime(element.to, date);
                if (now.isBefore(toDate, 'minute')) {
                    events.push({
                        event: 'closes',
                        moment: toDate
                    });
                }
            }
        }



        return events;

    }

    nextEvent() {
        var event = this.getEvents(2)[0];

        if (!event) {
            if (this.isOpen()) {
                return 'Jetzt geöffnet';
            } else {
                return 'Jetzt geschlossen';
            }
        }

        var str = event.moment.calendar(null, {
            sameDay: function (now) {
                return (event.event === 'opens') ? '[Öffnet um] LT [Uhr]' : '[Geöffnet bis] LT [Uhr]'
            },
            nextDay: function (now) {
                return (event.event === 'opens') ? '[Öffnet morgen um] LT [Uhr]' : '[Geöffnet bis morgen um] LT [Uhr]'
            },
            nextWeek: function (now) {
                return (event.event === 'opens') ? '[Öffnet am] dddd [um] LT [Uhr]' : '[Geöffnet bis] dddd[,] LT [Uhr]'
            },
        });

        return str;
    }


    groupExceptions() {
        var values = [];
        var exceptionDates = [];
        for (var date in this.exceptions) {
            exceptionDates.push(date);
        }
        var max = moment.unix(Math.max(...exceptionDates));
        var diff = max.clone().endOf('week').diff(moment().startOf('week'), 'days');

        var now = moment();
        for (let i = 0; i <= diff; i++) {
            var date = now.clone().startOf('day').add(i, 'days');
            values.push({
                date: date.unix(),
                openingTime: this.getOpeningTimeOfDate(date),
                exception: this.getExceptionOfDate(date)
            });
        }

        // Group same
        var start;
        var last = [];
        var lastEqualCount = 0;
        var lastRegularCount = 0;

        var groups = [];

        var addGroup = (range, group) => {
            if (range.length === 0) {
                return;
            }
            range = range.map(function(r) {
                r.date = moment.unix(r.date);
                return r
            });
            var fromRange = range[0].date;
            var toRange = range[range.length - 1].date;
            if (group) {
                groups.push({
                    dateStr: `${fromRange.format('L')} - ${toRange.format('L')}`,
                    openingTime: this.formatOpeningTime(range[0].exception || range[0].openingTime)
                });
            } else {
                for (let i = 0; i < range.length; i++) {
                    var element = range[i];
                    if (element.isException) {
                        groups.push({
                            dateStr: element.date.format('L'),
                            openingTime: this.formatOpeningTime(range[i].exception || range[i].openingTime)
                        });
                    }
                }
            }
        }

        for (var i = 0; i < values.length; i++) {
            var value = values[i];
            var openingTime = value.exception || value.openingTime;
            var isException = !!value.exception;

            var resVal = {
                date: value.date,
                openingTime: openingTime,
                isException: isException
            };
            
            if (!start) {
                start = resVal;
            }

            
            if (deepequal(start.openingTime, openingTime)) {
                if (!isException) {
                    lastRegularCount++
                } else {
                    lastRegularCount = 0;
                }
                lastEqualCount++;
            } else {
                addGroup(last, lastEqualCount > 3 && (lastEqualCount - lastRegularCount) > 2);
                last = [];
                start = resVal;
                lastEqualCount = 1;
            }
            if (i === values.length - 1) {
                addGroup(last, lastEqualCount > 3 && (lastEqualCount - lastRegularCount) > 2);
            }
            last.push(resVal);
        }

        return groups
    }



    formatOpeningTime(openingTimes) {
        let str = 'geschlossen';
        for (const openingTime of openingTimes) {
            if (str === 'geschlossen') {
                str = '';
            } else {
                str += ', ';
            }
            str += `${openingTime.from} - ${openingTime.to} Uhr`;
        }
        return str;
    }

    getOpeningTimesOfWeek() {
        let now = moment();
        let openingTimes = [];
        for (let i = 0; i < 7; i++) {
            let day = now.clone().add(i, 'day');
            openingTimes.push({
                dayName: day.format('dddd L'),
                openingTimes: this.getOpeningTimeOfDate(day, true),
                exception: this.getExceptionOfDate(day),
                isToday: i === 0
            })
        }
        return openingTimes;
    }



}

module.exports = openingTimes;